import {styled} from '@mui/material';

export const StyledImage = styled('img')({
  width: 50,
  height: 'auto'
});
